import React, { useState } from 'react'
import { Tabs, Tab, Box, Grid } from '@material-ui/core'
import { TabContext, TabPanel } from '@material-ui/lab'
import ActivitiesContainer from 'containers/ActivitiesContainer'
import TrainingPackagesContainer from 'containers/TrainingPackagesContainer'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import useTeamFeature from 'hooks/useTeamFeature'
import TeaserChip from 'components/Teaser/TeaserChip'
import useStyles from './styles'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const DrillsAndTrainingPackages = ({
  onPhaseSelect,
  onTrainingPackageSelect,
}) => {
  const [activeTab, setActiveTab] = useState('activities')

  const { enabled: hasActivitiesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.activities_enabled
  )
  const { enabled: hasTrainingPackagesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.training_packages_enabled
  )

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }
  const classes = useStyles()

  return (
    <Box>
      <TabContext value={activeTab}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="tabs"
          className={classes.tabsRoot}
        >
          <Tab
            label={
              <Grid>
                <Translate id="drills.activities" />
                {!hasActivitiesEnabled ? <TeaserChip /> : null}
              </Grid>
            }
            value="activities"
            className={classes.tab}
          />

          <Tab
            label={
              <Grid>
                <Translate id="navbar.training_packages" />
                {!hasTrainingPackagesEnabled ? <TeaserChip /> : null}
              </Grid>
            }
            value="training-packages"
            className={classes.tab}
          />
        </Tabs>
        <TabPanel value="activities" className={classes.tabPanel}>
          <ActivitiesContainer withPhaseMenu onPhaseSelect={onPhaseSelect} />
        </TabPanel>
        <TabPanel value="training-packages" className={classes.tabPanel}>
          <TrainingPackagesContainer
            showAddToPhaseButton
            onTrainingPackageSelect={onTrainingPackageSelect}
          />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
DrillsAndTrainingPackages.defaultProps = {
  onPhaseSelect: () => {},
  onTrainingPackageSelect: () => {},
}

DrillsAndTrainingPackages.propTypes = {
  onPhaseSelect: PropTypes.func,
  onTrainingPackageSelect: PropTypes.func,
}

export default DrillsAndTrainingPackages
